import {Comment, Form, List, Input, Button, Tag, Avatar, Popconfirm} from 'antd';
import moment from 'moment';
import React from "react";
import {compose} from "redux";
import {firestoreConnect} from "react-redux-firebase";
import {connect} from "react-redux";
import {createReply} from "../../Store/Actions/shop";
import {answerQuestion, deleteQuestion} from "../../Store/Actions/admin";
const { TextArea } = Input;

const Editor = ({ onSubmit }) => (
    <div className="uk-margin-top">
        <Form onFinish={onSubmit}>
            <Form.Item name="body" rules={[{ required: true }]} className="uk-margin-small-bottom">
                <TextArea placeholder="Enter your reply" rows={3} />
            </Form.Item>
            <Form.Item>
                <Button size="small" htmlType="submit" onClick={onSubmit} type="primary">
                    Reply
                </Button>
            </Form.Item>
        </Form>

    </div>
);

class Questions extends React.Component {


    state = {
        id: null
    };

    onSubmit = values => {
        if(values.body){
            answerQuestion(this.state.id, values.body, res => {
                this.setState({ id: null })
            });
        }
    };

    onDelete = id => {
        deleteQuestion(id);
    }

    render() {
        const { id } = this.state;
        const { questions } = this.props;
        const data = questions.map(question => {
            return {
                actions: !question.reply ? [
                    <span
                        onClick={ () => this.setState({ id: question.id===id ? null :question.id })}
                        key="comment-list-reply-to-0">
                        {question.id===id ? "Cancel reply" : "Reply"}
                    </span>
                ] : [],
                author: <span className="uk-text-emphasis">{question.author.name}</span>,
                avatar: question.author.avatar ? question.author.avatar : <Avatar style={{ color: '#1771F1', backgroundColor: '#B2C8F1' }}>{question.author.name[0].toUpperCase()}</Avatar>,
                content: (
                    <div>
                        <div>
                            <p>
                                { question.body }
                            </p>
                        </div>
                        <Popconfirm
                            title="Are you sure delete this question?"
                            onConfirm={() => this.onDelete(question.id)}
                            okText="Confirm"
                            cancelText="Cancel"
                        >
                            <Tag color="error">Delete</Tag>
                        </Popconfirm>
                        { id === question.id ?
                            <Editor onSubmit={this.onSubmit} />
                            : null }
                    </div>
                ),
                datetime: (
                    <span>
                      { moment(question.date.seconds*1000).fromNow() }
                    </span>
                ),
                reply: question.reply ? <Comment
                    content={<p>{ question.reply.body }</p>}
                    datetime={<span>{ moment(question.reply.date.seconds*1000).fromNow() }</span>}
                /> : null
            }
        });

        return (
            <div>
                <div className="uk-margin-bottom">
                    <div>
                        <h3 className="uk-h3 uk-margin-remove">
                            Questions
                        </h3>
                        <p className="uk-text-small uk-margin-remove">
                            { questions.length} questions
                        </p>
                    </div>
                </div>
                <List
                    className="comment-list"
                    itemLayout="horizontal"
                    dataSource={data}
                    renderItem={item => (
                        <li>
                            <Comment
                                actions={item.actions}
                                author={item.author}
                                avatar={item.avatar}
                                content={item.content}
                                datetime={item.datetime}
                            >
                                { item.reply }
                            </Comment>
                        </li>
                    )}
                />
            </div>
        );
    }
}


const mapStateToProps = (state, props) => {

    return {
        auth: state.firebase.auth,
        questions: state.firestore.ordered.questions ? state.firestore.ordered.questions : [],
        ...props
    }
}

const enhance = compose(
    firestoreConnect(props => [
        { collection: "questions" }
    ]),
    connect(mapStateToProps)
);
export default enhance(Questions);



// WEBPACK FOOTER //
// ./src/Components/Admin/Questions.js